export const TOKEN_CREATION_TIME = 'tokenCreationTime';
export const OAUTH2_TOKEN = 'oauth2Token';
export const GCS_OAUTH_TOKEN = 'gcsOauthToken';
export const MS_GRAPH_TOKEN = 'msGraphToken';
export const SCOPES = 'scopes';
